import type { FaireThemeEntity } from "../../entity_types/theme";

export const zen_and_spiritual_sanctuary: FaireThemeEntity = {
  token: "zen-and-spiritual-sanctuary",
  type: "theme",
  name: "Zen & Spiritual Sanctuary",
  description: "Enhance your store's mystical atmosphere with Palo Santo scents and crystal-inspired gifts. Perfect for your patrons seeking mindfulness and spiritual healing.",
  teaser: "Shiva's Gift Shop specializes in Vedic and Shamanic practices, crystals, and body-mind-spirit books. You have a proven interest in spiritual stones like smoky quartz and carnelian, as well as essential oils.",
  detail: "The additional_context shows you are currently carting Palo Santo Aroma Scented Candles, which aligns perfectly with your existing inventory of tapestries and meditation items.",
  bgColor: "#F0D4C4",
  tileBgColor: "#8c5244",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_mgsujmdxfg",
    "p_5rke2pmv4w",
    "p_dkqzuzwymp",
    "p_uhsawgu6bn",
    "p_j9g6pdps5f",
    "p_dubf45d3e4",
    "p_vwtvn3x6ep",
    "p_h4n7cqkgrs",
    "p_nae3q5kkn3",
    "p_ub33eu6bwv",
    "p_ut4y2ckn4j",
    "p_gjj78wsgvg",
    "p_z84dk4gk7g",
    "p_zyp5v9vdxa",
    "p_d6e69rjt4e",
    "p_9pjchz8tez",
    "p_qwzy2f6d9b",
    "p_g5629m787b",
    "p_6dnqzhx3bh",
    "p_bdfqunzkez",
    "p_att9f2he6e",
    "p_4qzqmsur49",
    "p_68c5r729gg",
    "p_vnvw8rfbt4",
    "p_rs3qkjyz5v",
    "p_w3k7sxeap3",
    "p_r6k377twtk",
    "p_n52gu9hsut",
    "p_xw64qza9gv",
    "p_8h4uw9pfe8",
    "p_st73wmcpw2",
    "p_y4vcvmvtzr",
    "p_5s87fkcwdv",
    "p_hf2b72dyx9",
    "p_z2hw82wyb4",
    "p_aa7ex4avg2",
    "p_zzq38g3qv7",
    "p_63dcq6w5c9",
    "p_5uq9wfmkcb",
    "p_tcytd8wpy9",
    "p_x8f6xuxfgy",
    "p_4z77wnfamb",
    "p_nfduu8xcyk",
    "p_2wujuzfwkx",
    "p_8tzrz5h2xg",
    "p_yfnpdjd5t6",
    "p_us6bdcbhmj",
    "p_jgkmj9u2uh",
    "p_y9xv3apx64",
    "p_k7yxvzm9vc",
    "p_4q6pqqdsyx",
    "p_mycnuu3ymp",
    "p_m9hpa8gf95",
    "p_fbjzqug4mk",
    "p_pvhwakvxms",
    "p_da7mkdqz7h",
    "p_szvdu4d8ma",
    "p_7dcqpf7jgh",
    "p_g9e3kqusus",
    "p_2rmcnjnw6h",
    "p_qq9bvd8cf3",
    "p_8j26mm97ha",
    "p_z8ws35rrwb",
    "p_tyvyv6psh6",
    "p_dk1ph1c8h1",
    "p_5wf93zqcct",
    "p_pdtm3hp3k5",
    "p_w4v6hnq4qn",
    "p_mt5k98hgpu",
    "p_hwuhk2jskt",
    "p_nejve3d29q",
    "p_b7vsk67ywt",
    "p_4rf273tyjf",
    "p_vxvz83rgb6",
    "p_n33msrc88v",
    "p_7uehrean34",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
